import { MessageData } from "src/components/types";
import "./GameChatPopup.css";
import { useCallback, useEffect, useRef } from "react";

type GameChatPopupProps = {
  messageData: MessageData | undefined;
};

export function GameChatPopup({ messageData }: GameChatPopupProps) {
  const popupRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<Animation | null>(null);
  useEffect(() => {
    if (!popupRef.current || !messageData?.message) return;

    const messageLength = messageData.message.length;
    const holdDuration = 2000 + messageLength * 50; // how long to stay visible
    const enterExitDuration = 500; // ms
    const totalDuration = holdDuration + 2 * enterExitDuration;

    const animation = popupRef.current.animate(
      [
        { opacity: 0, transform: "translate(255px, -95px) scale(0.01)", offset: 0 },
        { opacity: 1, transform: "translate(0, 0) scale(1)", offset: enterExitDuration / totalDuration },
        { opacity: 1, transform: "translate(0, 0) scale(1)", offset: 1 - enterExitDuration / totalDuration },
        { opacity: 0, transform: "translate(255px, -95px) scale(0.01)", offset: 1 },
      ],
      {
        duration: totalDuration,
        fill: "forwards",
      },
    );
    animationRef.current = animation;

    /*const timeout = setTimeout(() => {
      popupRef.current?.remove();
    }, totalDuration);*/

    return () => {
      animationRef.current?.cancel();
      //clearTimeout(timeout);
    };
  }, [messageData]);
  const hideMessage = useCallback(() => {
    animationRef.current?.cancel();
    const animation = popupRef.current?.animate([{ opacity: 0, transform: "translate(255px, -95px) scale(0.01)" }], {
      duration: 200,
      easing: "ease-in-out",
      fill: "forwards",
    });
  }, [popupRef.current]);

  if (!messageData) return null;
  if (messageData.username === localStorage.getItem("user-name") && messageData.type === "player-joined") {
    return null;
  }

  const messageDate = new Date(messageData.timestamp ?? 0).toLocaleString();

  return (
    <div
      ref={popupRef}
      key={messageData.timestamp}
      className={`game-chat-message-popup game-chat-message-popup-${messageData.type}`}
      onClick={hideMessage}
    >
      <div>
        <b className="game-chat-username">{messageData.username} </b>
        <span className="chat-date">{messageDate} </span>
      </div>
      <div className="game-chat-message">{messageData.message}</div>
    </div>
  );
}
